import validate from "/usr/src/app/content/n3-packages-82d55085-7669-4480-9c83-20fcc3f531f2/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-packages-82d55085-7669-4480-9c83-20fcc3f531f2/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}